import React from 'react'
import '../Styles/About.css'
import '../Styles/Fonts.css'
import aboutVideo from '../Resource/Gallery/Gallery_reel_1.mp4';

export const About = () => {
  return (
    <div className='Prasiddh-About-Container' id='About'>
        <h1>
            About Us
        </h1>
        <div className='Prasiddh-About-Text-container'>
            <div className='Prasiddh-About-Text-container-left'>
                <h1>SAAR Assets Management</h1>
                <p>
                At SAAR Assets Management, we create luxury villa communities where sustainability, innovation, and elegance come together. Each project is a thoughtfully designed ecosystem—energy-efficient, smart, and rooted in environmental responsibility.
                We go beyond building homes. We’re crafting spaces that inspire, endure, and contribute to a greener future. With every development, we ask what it means for the next generation—and build accordingly.
                SAAR — sustainable living, timeless impact.
                </p>
            </div>

            <div className='Prasiddh-About-Text-container-right'>
                <div>
                    <h1>Mr. Shree Ranga Prasad</h1>
                    <p>The land bore his name, but he carried it like a responsibility — not just to heritage, but to the future.
                    With grace, he let go of what was his, so something larger could take root.
                    A silent contributor, a steady believer — and the reason this dream found its place on earth. 
                    </p>
                </div>
                <div>
                    <h1>Visionary</h1>
                    <p> To lead the transformation of real estate by creating eco-conscious, high-quality living spaces that harmonize luxury with sustainability — setting a new global benchmark for responsible development and inspiring communities to live smarter, greener, and better.
                    </p>
                </div>
            </div>
        </div>
        <div className='About-video-container'>
            <div className='About-video-sub-container-1'>
                <div className='About-video-title'>Watch our project video to explore more about Prassidh</div>
                <div className='About-video-content'>At Prasiddh, sustainability is not an add-on — it’s the core of everything we build.</div>
                <div className='About-video-content'>From design to materials, every detail nurtures a thriving, low-impact community.</div>
                <div className='About-video-content'>With innovative architecture, renewable energy integration, and water-saving technologies, Prassidh sets a new standard in eco-living.</div>
            </div>
            <div className='About-video-sub-container-2'>
                <video
                    src={aboutVideo}
                    muted
                    loop
                    controls
                    autoPlay
                    className='About-video'
                    />

            </div>
        </div>
    </div>
  )
}
